// @flow
import * as React from "react";
import * as ReactDOM from "react-dom/client";

import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";

import bootstrap from "bootstrap/dist/js/bootstrap.bundle.min";

import App from "./App";
import ErrorBoundary from "./ErrorBoundary";
import ThemeProvider from "./providers/ThemeProvider";
import AntdConfigProvider from "./AntdConfigProvider";

import store from "./state/store";

import reportWebVitals from "./reportWebVitals";

import "./index.scss";

window.bootstrap = bootstrap;

const element = document.getElementById("root");

if (element !== null) {
  const root = ReactDOM.createRoot(element);

  root.render(
    <ErrorBoundary>
      <BrowserRouter basename="/">
        <Provider store={store}>
          <ThemeProvider>
            <AntdConfigProvider>
              <App />
            </AntdConfigProvider>
          </ThemeProvider>
        </Provider>
      </BrowserRouter>
    </ErrorBoundary>,
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
